import { fullLengthValueConfig } from '@alfa-bank/site-form-helpers/meta/is-error';
import type { TIsErrorFn, TMeta } from '@alfa-bank/site-form-helpers/src/meta/models';
import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';

const createIsError =
    (fullLengthValue: number): TIsErrorFn =>
    ({ active, dirtySinceLastSubmit, error, submitError, touched }: TMeta, value?: string) => {
        if (getNumbersFromStr(value).length === fullLengthValue && error) {
            return active || touched;
        }
        // Функция отличается от общей только '&& !active'
        if (error && !active) return touched;
        if (submitError) return !dirtySinceLastSubmit;

        return false;
    };

export const isPhoneError = createIsError(fullLengthValueConfig.phone);
export const isBirthdayError = createIsError(fullLengthValueConfig.birthday);
